<template>
    <div class="go">
        <!--导航栏-->
        <navbar :transparent="isTransparent" activeTo="Go"></navbar>
        <!--go-banenr-->
        <div class="go_banner">
            <h1 class="font_big">iGo</h1>
            <p class="font_mid" style="text-align: center">
                {{$t('go_banner_content')}}<br>{{$t('go_banner_content1')}}<br>{{$t('go_banner_content2')}}
            </p>
        </div>
        <!--go_content-->
        <div class="go_content">
            <div class="mogo_list">
                <Row>
                    <i-col :lg="8" :md="8" :sm="12" :xs="24" v-for="(list,index) in mogo_list" :key="index">
                        <div class="mogo_list_content">
                            <a>
                                <img :src="list.goods_img" @click="detail(list.goods_alias,list.goods_id)"/>
                            </a>
                            <div class="list_info">
                                <p class="font_mid">
                                    {{list.goods_name}}
                                </p>
                                <p class="font_small" v-html="list.goods_remark"></p>
                            </div>
                            <div class="list_addCart">
                                <div class="list_btn" v-if="list.store_count == 0">
                                    <button style="background: #ccc;">
                                        {{$t('store_mainpage_out_of_stock')}}
                                    </button>
                                </div>
                                <div class="list_btn" v-else>
                                    <button @click="addToCart(list.goods_id)">
                                        {{$t('add_to_cart')}}
                                    </button>
                                </div>
                                <a class="font_small" @click="detail(list.goods_alias,list.goods_id)">
                                    {{$t('learn_details')}} <Icon type="arrow-right-c"></Icon>
                                </a>
                            </div>
                        </div>
                    </i-col>
                </Row>
            </div>
        </div>
        <BackTop>
            <div class="top">
                <img src="../../assets/backtop/top.png">
                <p style="">{{$t('top_btn')}}</p>
            </div>
        </BackTop>
        <a href="http://ifree.ly/support" target="_blank">
            <BackTop :height="100" :bottom="110">
                <div class="top">
                    <img src="../../assets/backtop/service.png">
                    <p>{{$t('Service_btn')}}</p>
                </div>
            </BackTop>
        </a>
    </div>
</template>

<script>
    import navbar from '../Common/Navbar.vue'
    import Signature from '../../lib/Signature'
    export default {
        data () {
            return {
                isTransparent:false,
                mogo_list:[]
            }
        },
        components: {
            navbar
        },
        methods: {
            detail (good_name,id) {
                this.$router.push({
                    path: '/product/' + good_name,
                    query: {
                        id: id
                    }
                })
            },
            addToCart (id) {
                    //添加购物车
                    const module = 'index.php/index/shopcar/addcart'
                    let data = {}
                    data.sub_time = Signature.timestamp()
                    data.sign = Signature.create(module, data.sub_time)
                    data.goods_id = id
                    data.number = 1
                    data.lang = this.$i18n.locale
                    if (!this.Local.isLogin()) {
                        data.tourists_token = this.Local.get('tourists_token')
                    }else{
                        data.user_id = this.Local.getUserId()
                    }
                    this.$http.post(process.env.BASEURL + module, data)
                        .then(function (response) {
                            if (parseInt(response.data.code) === 2000) {
                                this.$Message.success(this.$t('added_successfully'))
                                // 添加到购物车事件
                                this.$busEvent.$emit('addCart', id)
                            }
                        }.bind(this))
            },
            //产品详情
            productDetail() {
                let module = 'index.php/index/goods/goodslist'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                data.lang = this.$i18n.locale
                data.type = 2
                this.$http.get(process.env.BASEURL + module, {
                    params: data
                }).then(function (resp) {
                    if (parseInt(resp.data.code) === 2000) {
                        this.mogo_list = resp.data.data.goods_list
                    }
                }.bind(this))

            }
        },
        created () {
            //产品详情
            this.productDetail()
        }
    }
</script>

<style lang="scss">
    @import "../../scss/_go.scss";
</style>



// WEBPACK FOOTER //
// Go.vue?6d8d5208